<div class="header">
    <h2>{{ 'licenses.modal.edit.title' | translate }}</h2>
    <button type="button" [attr.aria-label]="'common.close' | translate" class="close" data-test="licenses-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'licenses.error.unavailable' | translate" />
} @else if (license(); as license) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'licenses.fieldset.basic' | translate }}</h2>

            <div class="field">
                <span class="label">{{ 'licenses.form.packageId' | translate }}</span>
                <span class="value">{{ license.packageName }}</span>
            </div>

            <div class="field">
                <span class="label">{{ 'licenses.form.startAt' | translate }}</span>
                <span class="value">{{ license.startAt | date: 'medium' }}</span>
            </div>

            <app-form-datepicker
                [control]="form.controls.endAt"
                [label]="'licenses.form.endAt' | translate"
                [minDate]="minEndAt"
                inputId="endAt"
                testId="licenses-edit-end-at"
            />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'licenses.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="licenses-edit-cancel" (onClick)="close()" />
        <p-button type="submit" [label]="'licenses.form.save' | translate" [disabled]="saving()" data-test="licenses-edit-save" (onClick)="onSubmit()" />
    </div>
}
